import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class NotificationService {
    private readonly _snackBar = inject(MatSnackBar);

    success(message: string, durationMs = 3000) {
        this._snackBar.open(message, 'OK', {
            duration: durationMs,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: ['snackbar-success']
        });
    }

    error(message: string, durationMs = 5000) {
        this._snackBar.open(message, 'OK', {
            duration: durationMs,
            horizontalPosition: 'center',
            verticalPosition: 'bottom',
            panelClass: ['snackbar-error']
        });
    }
}
